import { NgModule } from '@angular/core';
import { RouterModule, Routes, UrlMatchResult, UrlSegment, UrlSegmentGroup } from '@angular/router';
import { CollectionOverviewComponent } from './containers/collection-overview/collection-overview.component';
import { ProductCatalogComponent } from './containers/product-catalog/product-catalog.component';
import { ProductDetailComponent } from './containers/product-detail/product-detail.component';
import { CollectionDetailGuard } from '../shop/guards/collection-detail.guard';
import { CollectionProductsGuard } from '../shop/guards/collection-products.guard';
import { CollectionsGuard } from '../shop/guards/collections.guard';
import { ProductDetailGuard } from '../shop/guards/product-detail.guard';
import { AllProductsGuard } from '../shop';
import { SearchResultsComponent } from './containers/search-results/search-results.component';
import { KlaviyoGuard } from '../shop/guards/klaviyo.guard';
import { CustomerGuard } from '../shop/guards/customer.guard';
import { SearchResultsGuard } from './guards/search-results.guard';

const routes: Routes = [
  {
    path: 'search',
    component: SearchResultsComponent,
    canActivate: [SearchResultsGuard],
  },
  {
    component: ProductDetailComponent,
    canActivate: [ProductDetailGuard, KlaviyoGuard, CustomerGuard],
    runGuardsAndResolvers: 'pathParamsChange',
    // If route is matching pattern /products/:productHandle
    matcher: (url: UrlSegment[], group: UrlSegmentGroup) => {
      return group.segments.length === 2 && group.segments[0].path.endsWith('products')
        ? { consumed: url, posParams: { productHandle: group.segments[1] } }
        : null;
    },
  },
  {
    component: ProductCatalogComponent,
    canActivate: [AllProductsGuard],
    // If route is matching pattern /products
    matcher: (url: UrlSegment[], group: UrlSegmentGroup, route) => {
      const parentSeg = group?.parent?.segments;
      return parentSeg?.length === 1 && parentSeg?.[0]?.path.endsWith('products') ? { consumed: url } : null;
    },
  },
  {
    path: '',
    component: CollectionOverviewComponent,
    canActivate: [CollectionsGuard],
  },
  {
    path: ':collectionHandle',
    component: ProductCatalogComponent,
    canActivate: [CollectionDetailGuard, CollectionProductsGuard],
    runGuardsAndResolvers: 'pathParamsChange',
  },
  {
    path: ':collectionHandle/:productHandle',
    component: ProductDetailComponent,
    canActivate: [CollectionDetailGuard, ProductDetailGuard, KlaviyoGuard, CustomerGuard],
    runGuardsAndResolvers: 'pathParamsChange',
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CatalogRoutingModule {}
